import { axios } from '@util';

class FCP {
  async getUMRs(role, roleValue) {
    return await axios({
      url: '/lincoln/api/get/fcp/umrs/list/',
      params: {
        role: role,
        role_value: roleValue,
      },
    });
  }
}

export default new FCP();
